import { useQuery } from "@tanstack/react-query";

export function useGetDistributionsByIds({
  callApiWithWorker,
  ids,
  language,
  enabled = true,
}) {
  const stableIds = Array.isArray(ids) ? [...ids].filter(Boolean).sort() : [];

  return useQuery({
    queryKey: ["distributionsByIds", stableIds.join("|"), language || ""],
    enabled: enabled && stableIds.length > 0,
    queryFn: async ({ signal }) => {
      const results = await Promise.allSettled(
        stableIds.map(async (id) => {
          const langQuery = language
            ? `?lang=${encodeURIComponent(language)}`
            : "";
          const res = await callApiWithWorker(
            `/distributions/${id}${langQuery}`,
            {
              method: "GET",
              signal,
            },
          );

          const body =
            typeof res?.body === "string"
              ? (() => {
                  try {
                    return JSON.parse(res.body);
                  } catch {
                    return res?.data ?? res;
                  }
                })()
              : (res?.data ?? res);

          return body;
        }),
      );

      return results
        .filter((result) => result.status === "fulfilled")
        .map((result) => result.value);
    },
  });
}
